// extracted by mini-css-extract-plugin
export default {"root":"GetStarted_root__8+R6H","link":"GetStarted_link__UwDHO"};